module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "x01_9781118243251-ffirs.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "BC",
      "src": "images/BCLogo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BookTitle"
  }, [_vm._v("20-minute meals")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "wileytitlepagelogo.eps",
      "src": "images/WileyTitlePageLogo_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CP-First"
  }, [_vm._v("Copyright © 2012 by General Mills, Minneapolis, Minnesota. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("Published by John Wiley & Sons, Inc., Hoboken, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("Published simultaneously in Canada")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, scanning, or otherwise, except as permitted under Section 107 or 108 of the 1976 United States Copyright Act, without either the prior written permission of the Publisher, or authorization through payment of the appropriate per-copy fee to the Copyright Clearance Center, Inc., 222 Rosewood Drive, Danvers, MA 01923, (978) 750-8400, fax (978) 750-4470, or on the web at "), _c('a', {
    attrs: {
      "href": "http://www.copyright.com",
      "target": "_blank"
    }
  }, [_vm._v("www.copyright.com")]), _vm._v(". Requests to the Publisher for permission should be addressed to the Permissions Department, John Wiley & Sons, Inc., 111 River Street, Hoboken, NJ 07030, (201) 748-6011, fax (201) 748-6008, or online at "), _c('a', {
    attrs: {
      "href": "http://www.wiley.com/go/permissions",
      "target": "_blank"
    }
  }, [_vm._v("http://www.wiley.com/go/permissions")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("Trademarks: Wiley and the Wiley logo are trademarks or registered trademarks of John Wiley & Sons and/or its affiliates. All other trademarks referred to herein are trademarks of General Mills. John Wiley & Sons, Inc., is not associated with any product or vendor mentioned in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("Limit of Liability/Disclaimer of Warranty: While the publisher and author have used their best efforts in preparing this book, they make no representations or warranties with respect to the accuracy or completeness of the contents of this book and specifically disclaim any implied warranties of merchantability or fitness for a particular purpose. No warranty may be created or extended by sales representatives or written sales materials. The advice and strategies contained herein may not be suitable for your situation. You should consult with a professional where appropriate. Neither the publisher nor author shall be liable for any loss of profit or any other commercial damages, including but not limited to special, incidental, consequential, or other damages.")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("For general information on our other products and services or for technical support, please contact our Customer Care Department within the United States at (800) 762-2974, outside the United States at (317) 572-3993 or fax (317) 572-4002.")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("Wiley publishes in a variety of print and electronic formats and by print-on-demand. Some material included with standard print versions of this book may not be included in e-books or in print-on-demand. If this book refers to media such as a CD or DVD that is not included in the version you purchased, you may download this material at "), _c('a', {
    attrs: {
      "href": "http://booksupport.wiley.com",
      "target": "_blank"
    }
  }, [_vm._v("http://booksupport.wiley.com")]), _vm._v(". For more information about Wiley products, visit "), _c('a', {
    attrs: {
      "href": "http://www.wiley.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wiley.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("ISBN: 978-1-118-24325-1  (ebk); ISBN: 978-1-118-24321-3 (ebk)")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Title"
  }, [_vm._v("General Mills")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Publisher, Cookbooks:")]), _vm._v(" Maggie Gilbert/Lynn Vettel")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Manager and Editor, Cookbooks:")]), _vm._v(" Lois Tlusty")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Recipe Development and Testing:")]), _vm._v(" Betty Crocker Kitchens")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Photography and Food Styling:")]), _vm._v(" General Mills Photography Studios and Image Library")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Title"
  }, [_vm._v("John Wiley & Sons, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Publisher:")]), _vm._v(" Natalie Chapman")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Associate Publisher:")]), _vm._v(" Jessica Goodman")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Executive Editor:")]), _vm._v(" Anne Ficklen")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Editor:")]), _vm._v(" Greg Friedman")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Production Manager:")]), _vm._v(" Michael Olivo")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Cover Design:")]), _vm._v(" Suzanne Sunwoo")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Art Director:")]), _vm._v(" Tai Blanche")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Layout:")]), _vm._v(" Indianapolis Composition Services")]), _vm._v(" "), _c('p', {
    staticClass: "CP-Credit-Names"
  }, [_c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Manufacturing Manager:")]), _vm._v(" Kevin Watt")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("Cover photo: "), _c('a', {
    attrs: {
      "href": "#/05_9781118243251ch02#a01"
    }
  }, [_vm._v("Broiled Dijon Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_c('img', {
    attrs: {
      "alt": "bccopyrightlogo.jpg",
      "src": "images/bccopyrightlogo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Betty-Letter-Welcome"
  }, [_vm._v("Dear Friends,")]), _vm._v(" "), _c('p', {
    staticClass: "Betty-Letter"
  }, [_vm._v("Feeling the time crunch? Think that your dinner possibilities are limited to take-out meals, ordering-in pizza, or buying frozen meals? It doesn’t have to be that way! Try any of these delicious recipes, and you’ll have dinner on the table in just 20 minutes—or less—no kidding!")]), _vm._v(" "), _c('p', {
    staticClass: "Betty-Letter"
  }, [_vm._v("Sound too good to be true? You can make a meal in 20 minutes and still enjoy quality and diversity. Enjoy "), _c('a', {
    attrs: {
      "href": "#/05_9781118243251ch02#a01"
    }
  }, [_vm._v("Broiled Dijon Burgers")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/06_9781118243251ch03#a04"
    }
  }, [_vm._v("Stove-Top Lasagna")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/07_9781118243251ch04#a07"
    }
  }, [_vm._v("Breaded Pork Chops")]), _vm._v("; branch out with recipes such as "), _c('a', {
    attrs: {
      "href": "#/05_9781118243251ch02#a03"
    }
  }, [_vm._v("Grilled Fish Tacos")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/07_9781118243251ch04#a03"
    }
  }, [_vm._v("Steak with Mango-Peach Salsa")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/07_9781118243251ch04#a05"
    }
  }, [_vm._v("Pad Thai–Style Chicken")]), _vm._v(". You may end up throwing out those take-out menus on the fridge! ")]), _vm._v(" "), _c('p', {
    staticClass: "Betty-Letter"
  }, [_vm._v("With these reliable recipes and time-saving tips, you can feel confident about putting a fresh, high-quality, home-cooked meal on your table every night. No matter how crowded your day or how hectic your family schedule may be, relax and leave it to Betty. So, why not sit down to a real meal tonight—connect with your family, savor flavorful food and remember how wonderful a real meal can be?")]), _vm._v(" "), _c('p', {
    staticClass: "Betty-Letter-Warmly"
  }, [_vm._v("Warmly, ")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "BC",
      "src": "images/BCLogo.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34132ea2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01_9781118243251-ffirs.vue
// module id = 57
// module chunks = 0